// eslint-disable-next-line import/no-extraneous-dependencies
import { DateTime, IANAZone } from 'luxon';

export type TimeZoneOption = {
  label: string;
  value: string;
};

export const timezoneMapping: Record<string, string> = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Europe/Kiev': 'Europe/Kyiv',
  'America/Godthab': 'America/Nuuk',
  'Asia/Chungking': 'Asia/Shanghai',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Pacific/Yap': 'Pacific/Chuuk',
  'Africa/Timbuktu': 'Africa/Bamako',
  'America/Porto_Acre': 'America/Rio_Branco',
  'America/Atka': 'America/Adak',
  'Asia/Ujung_Pandang': 'Asia/Makassar',
  'Asia/Dacca': 'Asia/Dhaka',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Asia/Phnom_Penh': 'Asia/Bangkok',
  'Asia/Rangoon': 'Asia/Yangon',
  'Europe/Belfast': 'Europe/London',
  'Europe/Tiraspol': 'Europe/Chisinau',
};

/**
 * Normalizes a legacy timezone name to its modern IANA equivalent.
 * @param {any} tz - The tz
 */
export const normalizeTimeZone = (tz: string): string => {
  return timezoneMapping[tz] || tz;
};

/**
 * Get all IANA timezones
 */
export const getTimeZones = (): TimeZoneOption[] => {
  try {
    const zones = (Intl as any).supportedValuesOf('timeZone') as string[];

    // Map to canonical names and remove duplicates
    const canonicalZones = Array.from(new Set(zones.map((z) => normalizeTimeZone(z))));

    return canonicalZones
      .filter((zone: string) => IANAZone.isValidZone(zone))
      .map((zone: string) => ({
        label: zone,
        value: zone,
      }))
      .sort((a: TimeZoneOption, b: TimeZoneOption) => a.label.localeCompare(b.label));
  } catch {
    return [
      { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
      { label: 'America/New_York', value: 'America/New_York' },
      { label: 'Europe/London', value: 'Europe/London' },
    ];
  }
};

/**
 * Detect user's timezone
 */
export const getUserTimeZone = (): string => {
  try {
    const tz = DateTime.local().zoneName;

    if (IANAZone.isValidZone(tz)) {
      return normalizeTimeZone(tz);
    }

    return 'Asia/Kolkata';
  } catch {
    return 'Asia/Kolkata';
  }
};
